interface ISocialIconProps {
  width?: string
  height?: string
}

const ESocialIcon = ({ width = '32', height = '24' }: ISocialIconProps) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 32 24'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      xlinkHref='http://www.w3.org/1999/xlink'
    >
      <rect
        width='32'
        height='24'
        fill='url(#pattern0_271_4175)'
      />
      <defs>
        <pattern
          id='pattern0_271_4175'
          patternContentUnits='objectBoundingBox'
          width='1'
          height='1'
        >
          <use
            xlinkHref='#image0_271_4175'
            transform='matrix(0.0136054 0 0 0.0204082 0.173469 0)'
          />
        </pattern>
        <image
          id='image0_271_4175'
          width='48'
          height='49'
          xlinkHref='data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAxCAYAAACcXioiAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAQ3SURBVHgB7ZpbaBxVGMf/Mzt7STa70XabVkFopRZBpQ8G1IfaIKQq+lDFvKhQUrTQ1uqDWPFB1AdBsVrwoYISqFKIBVtEWigkBXunLb039L40vSXdbrJpspfsXM7pd3a7STZ7SdOdk+nC/mDY3bNnZr//+c75vu/MrMI5/xaSiEePo+33zzBkwlZ8Hh/aXm7DmpZVUEgAhwwSYYycWIPXuyNIMAV2o6ou/Pje93IE8OEzYD2fIpGI4o29biRgvwBBU7AJGmyGD5+GdXIFvbEynxmj8VHlCIjFY1BhI3xgD6xTK8eMFzBLzgzNYZsHdl+JYunNT8j4/NEOBWbB8HhQKUk9hfhovKDdljXwd08EK3b2YcvC3/DO7INj7abiRde8LzA3uACVcvjSEfzR1UGraXyA3Kq78in018kIPthxGyaN/ObIErp8/ngYlgkxRpUeKDHMFQnYcOAW2nf1I3f1c6kmWJOmkMltTgKTeGgBP+2/gS/3RTExQqZYADornO/WhEVtN9NexIzcub77BjYei2FyeBd+UBRWcI7JTLhcLshgWh5ImyZW7+rFxuOFxgtmu4fgU9MF7YZlQBYP7AHdZFi14yq2XEiW7POK/wp5oXBMDOawgKFkGh/v7MX28GjZfquf6EIx1+hMhyymFBCJ6/hw+2XsvmWhXEnTGuzBYvJAsU4mc2gRX7ubwvv/XsOh/vLGz3OP4NcFm1GqkyNR6OJAEm/9cxXhKYr5OVoSnc9swtN1fSX7MMYoGTGKULaWXhmKCkgmo1i+7U554ylmLvZfR8fCTXih/jrKwch4C4x+bAYE8JGz8PSsRedTQXR4l2JbdAn6Db8wA2KKBFQTLY3n0D63G681nkadOvUCpWIgkz9kbAvyBDCxETm7juJeDM/Vx/DL/D+xgY7+dBMSlhf1Lh0hd4xivU4mTc8ak2oiDxVfdjMmgA8eoon/NRk/OOFrJeP0J7138k7iDzGUlqSaKCOAD/wPdv4rcDMBOxl2PU4ldbY2MpgkAXrff2DhnynbjBuvKFR1q5UsOAV3tTk4Gnh7rMWUlI219s4fkE6nwJkKkW/EHra1uQXPzl+Uid8i/E0XpmgY0kJ5bbJufmgXhxml+vHRFhGDBxfBP+vFTPgTh6gmRTYVggxuwBLv7x/UI3vOFAY2eBogRUCpL1RKOur9xONxFd/TitAoRIkFarGsUPE59yrEK7TBCXgD8Lv9mFEBD4JKa0Wl6eIWlylS7ud8IuemShbb7wtNRKbhOezP7TNMTYDT1AQ4TU2A09QEOE1NgNPUBDhN1QsoXk4r2X3xI0UJc5Tmb17i+qQNd4PPjzpvPR4lUuIpZSr/KaV4yFfUA/HRROaoBqp/ETf6H0O1EgqGoK5/83O4VDkP4GQi/q3y0asroS17vvW78GAvth7cCl0fRTXg0XxYt2wt3m1ejntI3+rnNiz0oQAAAABJRU5ErkJggg=='
        />
      </defs>
    </svg>
  )
}

export default ESocialIcon
